export default {
  news: '/news',
  newsCategory: '/news/category',
}
